import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GasComparatorResult } from 'src/app/components/account/models/GasComparatorResult';
import { ModalDocumentsComponent } from '../modal-documents/modal-documents.component';
import Swal from "sweetalert2";
import {environment} from "../../../../environments/environment";
import {forkJoin, of} from "rxjs";
import {map} from "rxjs/internal/operators";
import {catchError} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FeignComparatorService} from "../services/feign.comparator.service";

@Component({
  selector: 'app-gas-comparator-table',
  templateUrl: './gas-comparator-table.component.html',
  styleUrls: ['./gas-comparator-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GasComparatorTableComponent implements OnInit {

  @Input('comparatorForm') comparatorForm: FormGroup;
  @Input('gasComparatorResults') gasComparatorResults: GasComparatorResult[];

  public insertActualprice: string = "(introduceți prețul actual)";
  public enterData: string = "(introduceți datele)";
  public enterEstimatedConsumption: string = "(introduceți consumul estimat)";
  public gasComparisonResultsNote: string = "Notă: Preţurile de furnizare afișate nu conțin TVA. Valoarea cu T.V.A. a acestora poate fi vizualizată trecând cursorul mouse-ului peste valoarea afișată în tabel.<br>Valoarea facturii estimate conform ofertei-tip, afișată în tabel, conține T.V.A. și în cazul clienților noncasnici și acciza.<br> Clienții casnici și organizațiile de caritate sunt scutiți de la plata accizei pentru gazul natural (conform Codului Fiscal și a Normelor metodologice de aplicare)";
  public comparisonResults: string = "Rezultate comparare";
  public noCrt: string = "Nr. crt.";
  public supplier: string = "Furnizor";
  public offerTypeName: string = " Denumire oferta-tip";
  public naturalGasPrice: string = "Preţ gaze naturale (lei/MWh)";
  public shippingCost: string = "Cost de transport (lei/MWh)";
  public distributionCost: string = "Tarif de distribuţie (lei/MWh)";
  public supplyPriceLeiMwh: string = "Preţ de furnizare (lei/MWh)";
  public supplyPriceLeiKwh: string = "Preţ de furnizare (lei/KWh)";
  public cfValue: string = "Valoare Componentă fixă (abonament) (lei/zi)";
  public comparisonResult: string = "Rezultat comparație preţ oferta-tip/preţ actual (include si valoarea abonamentului lunar) (%)";
  public invoiceValue: string = "Valoare factură estimată conform ofertei-tip (include si valoarea abonamentului lunar) (cu TVA, si acciza, după caz) (lei)";
  public economyCost: string = "Economie/Cost suplimentar lunar (lei)";
  public offerTypedetails: string = "Detalii ofertă-tip";
  public requiredDocuments: string = "Documente necesare contractării ofertei-tip";
  public closeDetails: string = "Inchide detalii";
  public viewDetails: string = "Vezi detalii";
  public open: string = "Deschide";
  public selectOffer: string = "Selecteaza oferta";
  public isSelectOfferButtonVisible: boolean;
  public isMobileList: boolean;
  public sortBy: string;
  public sortDirection: string;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileList = window.innerWidth <= 991;
  }

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private comparatorService: FeignComparatorService
  ) {
    this.isMobileList = window.innerWidth <= 991;
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length && (params.clientTypePF || params.clientTypePJ)) {
        this.isSelectOfferButtonVisible = true;
      } else {
        this.isSelectOfferButtonVisible = false;
      }
    });
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value &&
      this.comparatorForm.controls.supplyPriceLeiMwh.value &&
      this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value > 0) {
      this.onSort(this.economyCost, "up");
    } else {
      this.onSort(this.invoiceValue, "up");
    }
  }

  onExpandDetails(gasComparatorResult: any): any {
    gasComparatorResult.isSubRowDisplayed = !gasComparatorResult.isSubRowDisplayed;
  }

  onConvertToNumber(value: any, decimals?: number): number {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string') {
      value = parseFloat(value.replace(",", "").replace(/--/, "-"));
    }
    return decimals ? parseFloat(value.toFixed(decimals)) : value;
  }

  openDocumentsModal(gasComparatorResult: GasComparatorResult): void {
    const modalRef = this.modalService.open(ModalDocumentsComponent, { size: 'lg' });
    modalRef.componentInstance.gasComparatorResult = gasComparatorResult;
  }

  saveOfferToStorage(gasComparatorResult: GasComparatorResult): void {
    localStorage.setItem('gasComparatorResult', JSON.stringify(gasComparatorResult));
  }

  checkAndSaveOfferToStorage(gasComparatorResult: GasComparatorResult): void {
      console.log('checkAndSaveOfferToStorage', gasComparatorResult);

      if (!gasComparatorResult.posf_ready) {
      Swal.fire({
        html: '<span>Oferta selectată nu prezintă datele tehnice necesare contractării/schimbării furnizorului direct prin intermediul POSF. ' +
          'Pentru a continua cu această ofertă vă rugăm să contactați furnizorul în scopul contractării/schimbării ' +
          'furnizorului prin mecanisme alternative puse la dispoziția dumneavoastră de către acesta.</span>',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Anuleaza',
        customClass: {
          popup: 'popup-z-elevate-24-red popup-wide popup-with-list'
        }
      });
      return;
    }

    const documentTypes = this.comparatorService.getComparatorDocumentTypes(
      localStorage.getItem('comparatorType'),
      localStorage.getItem('supplierLicence'),
      localStorage.getItem('comparatorType') === 'electric' ? localStorage.getItem('electricComparatorResult')
        : (localStorage.getItem('comparatorType') === 'gas' ? localStorage.getItem('gasComparatorResult') : null),
      localStorage.getItem('clientTypePF') === 'true',
      localStorage.getItem('clientTypePJ') === 'true'
    );
    const documents = gasComparatorResult.documente
      .filter(x => x.fisier && x.fisier.trim())
      .filter(x => documentTypes.includes(x.tip_document));
    const modelContract = gasComparatorResult.model_contract;
    const fileLinks = [];
    if (documents && documents.length) {
      documents.forEach(doc => {
        const url = environment.comparatorDocumentsUrl + 'contracte_gaz/' + doc.fisier;
        fileLinks.push({url, name: doc.fisier, type: doc.tip_document});
      });
    }
    if (modelContract) {
      const url = environment.comparatorDocumentsUrl + 'furnizori_gaz/' + modelContract;
      fileLinks.push({url, name: modelContract, type: 'model_contract'});
    }
    console.log('fileUrls', fileLinks);
    const urlObservables = fileLinks.map(link => this.testUrl(link.url));
    const failedLinks = [];
    forkJoin(urlObservables).subscribe((results) => {
      results.forEach((result, index) => {
        if (!result) {
          failedLinks.push(fileLinks[index]);
        }
      });
      console.log('failedLinks', failedLinks);

      let popupMessage = '';
      if (failedLinks.length > 0) {
        popupMessage += '<span>Oferta selectată conține documente care nu pot fi accesate. ' +
          'Vă rugăm să contactaţi furnizorul pentru a actualiza documentele aferente sau pentru a contracta direct în baza ofertei selectate.</span>';
        popupMessage += '<br><span>Documente care nu pot fi accesate:</span><ul>';
        failedLinks.forEach(link => {
          popupMessage += `<li>${link.name || link.type}</li>`;
        });
        popupMessage += '</ul>';
      }

      if (popupMessage) {
        console.log('popupMessage', popupMessage);
        Swal.fire({
          html: popupMessage,
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
          customClass: {
            popup: 'popup-z-elevate-24-red popup-wide popup-with-list'
          }
        });
        return;
      }

      this.saveOfferToStorage(gasComparatorResult);
      this.router.navigate(['utilizator','schimba-furnizor']);
    });
  }

  testUrl(url: string) {
    // Perform a HEAD request to check if the URL is accessible
    return this.http.head(url, { observe: 'response' }).pipe(
      map(() => true), // Return true if the request succeeds
      catchError(() => of(false)) // Return false if the request fails
    );
  }

  onComputeInvoiceValueTvaExcise(gasComparatorResult: GasComparatorResult): number {
    let estimatedMonthlyConsumptionMwh: number;
    if (this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value) {
      estimatedMonthlyConsumptionMwh = this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value;
    } else {
      estimatedMonthlyConsumptionMwh = 1;
    }
    return this.onConvertToNumber(((this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value *
      this.onConvertToNumber(gasComparatorResult.pret_furnizare_mwh))
      + this.onConvertToNumber(gasComparatorResult.acciza)
      + gasComparatorResult.cf * 30) * (1 + this.onConvertToNumber(gasComparatorResult.tva) / 100), 2);
  }

  onSort(column: string, direction: string): void {
    switch (column) {
      case this.supplier:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.nume.trim() > b.nume.trim()) ? 1 : ((b.nume.trim() > a.nume.trim()) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.nume.trim() < b.nume.trim()) ? 1 : ((b.nume.trim() < a.nume.trim()) ? -1 : 0));
          }
          this.sortBy = 'supplier';
          break;
        }
      case this.naturalGasPrice:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.pg > b.pg) ? 1 : ((b.pg > a.pg) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.pg < b.pg) ? 1 : ((b.pg < a.pg) ? -1 : 0));
          }
          this.sortBy = 'naturalGasPrice';
          break;
        }
      case this.shippingCost:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.tt > b.tt) ? 1 : ((b.tt > a.tt) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.tt < b.tt) ? 1 : ((b.tt < a.tt) ? -1 : 0));
          }
          this.sortBy = 'shippingCost';
          break;
        }
      case this.distributionCost:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.t0 > b.t0) ? 1 : ((b.t0 > a.t0) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.t0 < b.t0) ? 1 : ((b.t0 < a.t0) ? -1 : 0));
          }
          this.sortBy = 'distributionCost';
          break;
        }
      case this.supplyPriceLeiMwh:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.pret_furnizare_mwh > b.pret_furnizare_mwh) ? 1 : ((b.pret_furnizare_mwh > a.pret_furnizare_mwh) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.pret_furnizare_mwh < b.pret_furnizare_mwh) ? 1 : ((b.pret_furnizare_mwh < a.pret_furnizare_mwh) ? -1 : 0));
          }
          this.sortBy = 'supplyPriceLeiMwh';
          break;
        }
      case this.supplyPriceLeiKwh:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (this.onConvertToNumber(a.pret_furnizare_kwh.replace(",", "")) > this.onConvertToNumber(b.pret_furnizare_kwh.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.pret_furnizare_kwh.replace(",", "")) > this.onConvertToNumber(a.pret_furnizare_kwh.replace(",", ""))) ? -1 : 0)));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (this.onConvertToNumber(a.pret_furnizare_kwh.replace(",", "")) < this.onConvertToNumber(b.pret_furnizare_kwh.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.pret_furnizare_kwh.replace(",", "")) < this.onConvertToNumber(a.pret_furnizare_kwh.replace(",", ""))) ? -1 : 0)));
          }
          this.sortBy = 'supplyPriceLeiKwh';
          break;
        }
      case this.cfValue:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.cf > b.cf) ? 1 : ((b.cf > a.cf) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.cf < b.cf) ? 1 : ((b.cf < a.cf) ? -1 : 0));
          }
          this.sortBy = 'cfValue';
          break;
        }
      case this.comparisonResult:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (a.rezultat_comparatie > b.rezultat_comparatie) ? 1 : ((b.rezultat_comparatie > a.rezultat_comparatie) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (a.rezultat_comparatie < b.rezultat_comparatie) ? 1 : ((b.rezultat_comparatie < a.rezultat_comparatie) ? -1 : 0));
          }
          this.sortBy = 'comparisonResult';
          break;
        }
      case this.invoiceValue:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (this.onComputeInvoiceValueTvaExcise(a) > this.onComputeInvoiceValueTvaExcise(b)) ? 1 : ((this.onComputeInvoiceValueTvaExcise(b) > this.onComputeInvoiceValueTvaExcise(a)) ? -1 : 0));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (this.onComputeInvoiceValueTvaExcise(a) < this.onComputeInvoiceValueTvaExcise(b)) ? 1 : ((this.onComputeInvoiceValueTvaExcise(b) < this.onComputeInvoiceValueTvaExcise(a)) ? -1 : 0));
          }
          this.sortBy = 'invoiceValue';
          break;
        }
      case this.economyCost:
        {
          if (direction == "up") {
            this.sortDirection = "up";
            this.gasComparatorResults.sort((a, b) => (this.onConvertToNumber(a.economie_sau_cost.replace(",", "")) > this.onConvertToNumber(b.economie_sau_cost.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.economie_sau_cost.replace(",", "")) > this.onConvertToNumber(a.economie_sau_cost.replace(",", ""))) ? -1 : 0)));
          }
          if (direction == "down") {
            this.sortDirection = "down";
            this.gasComparatorResults.sort((a, b) => (this.onConvertToNumber(a.economie_sau_cost.replace(",", "")) < this.onConvertToNumber(b.economie_sau_cost.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.economie_sau_cost.replace(",", "")) < this.onConvertToNumber(a.economie_sau_cost.replace(",", ""))) ? -1 : 0)));
          }
          this.sortBy = 'economyCost';
          break;
        }
    }
  }

  onMouseOverTvaMwh(tVAPriceMwhTemplate: HTMLElement): void {
    tVAPriceMwhTemplate.style.display = "block";
  }

  onMouseLeaveTvaMwh(tVAPriceMwhTemplate: HTMLElement): void {
    tVAPriceMwhTemplate.style.display = "none";
  }

  onMouseOverTvaKwh(tVAPriceKwhTemplate: HTMLElement): void {
    tVAPriceKwhTemplate.style.display = "block";
  }

  onMouseLeaveTvaKwh(tVAPriceKwhTemplate: HTMLElement): void {
    tVAPriceKwhTemplate.style.display = "none";
  }

}
